import { TRACE_TARGET_REGEX } from '@milestone-portal/common/constants';
import OpenReplay from '@openreplay/tracker';

import { sentryCaptureException } from './sentry';

let openReplay: OpenReplay | undefined;

export const getOpenReplay = () => {
  if (openReplay) return openReplay;

  const { VITE_APP_OPEN_REPLAY_PROJECT_KEY } = import.meta.env;
  if (!VITE_APP_OPEN_REPLAY_PROJECT_KEY) return null;

  try {
    const tracker = new OpenReplay({
      network: {
        captureInIframes: true,
        capturePayload: true,
        failuresOnly: false,
        ignoreHeaders: ['Cookie', 'Set-Cookie', 'Authorization'],
        sanitizer: (data) => {
          return data;
        },
        sessionTokenHeader: false,
        tokenUrlMatcher: (url) => {
          return TRACE_TARGET_REGEX.test(url);
        },
      },
      obscureInputEmails: false,
      obscureTextEmails: false,
      projectKey: VITE_APP_OPEN_REPLAY_PROJECT_KEY,
    });
    openReplay = tracker;

    tracker.start({
      metadata: {
        domain: window.location.hostname,
        version: APP_VERSION,
      },
    });
    return tracker;
  } catch (error) {
    sentryCaptureException(error);
  }
  return null;
};
